import React, { useEffect, useState } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { Auth } from 'aws-amplify';
import { LoadingSpinner } from './ui';

export default function PublicRoute() {
  const [authState, setAuthState] = useState('loading');

  useEffect(() => {
    Auth.currentAuthenticatedUser()
      .then(() => setAuthState('authenticated'))
      .catch(() => setAuthState('unauthenticated'));
  }, []);

  if (authState === 'loading') return <LoadingSpinner size="lg" className="min-h-screen" />;
  if (authState === 'authenticated') return <Navigate to="/" replace />;
  return <Outlet />;
}
